<template>
  <div class="files-container">
    <div class="upload-wrapper">
      <proa-button @click.native="uploadProjectAttachmentModal = true">{{ $t('common.upload') }}</proa-button>
    </div>
    <div class="content-container">
      <div class="table-outer-wrapper">
        <div class="table-inner-scroll-wrapper">
          <table class="table-files">
            <thead>
              <tr>
                <th>
                  <div class="attribute-name">
                    <span>{{ $t('models.projectAttachment.attributes.attachmentFileName') }}</span>
                  </div>
                </th>
                <th>
                  <div class="attribute-name">
                    <span>{{ $t('models.projectAttachment.attributes.attachmentOwner') }}</span>
                  </div>
                </th>
                <th>
                  <div class="attribute-name">
                    <span>{{ $t('models.projectAttachment.attributes.updatedAt') }}</span>
                  </div>
                </th>
                <th colspan="2">
                  <div class="attribute-name">
                    <span>{{ $t('models.projectAttachment.attributes.attachmentFileSize') }}</span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="projectAttachment of projectAttachments" :key="projectAttachment.id">
                <td>{{ projectAttachment.attachmentFileName }}</td>
                <td>
                  <template v-if="projectAttachment.getUser()">
                    <proa-avatar :src="projectAttachment.getUser().meta.avatar || require('@/assets/images/avatar_default.png')" size="sm"/>
                    <span class="ml-3">{{ projectAttachment.getUser().meta.displayName }}</span>
                  </template>
                </td>
                <td>{{ projectAttachment.updatedAt | moment('YYYY/MM/DD HH:mm') }}</td>
                <td>{{ projectAttachment.attachmentFileSize | formatByteDisplay }}</td>
                <td>
                  <div class="file-items">
                    <div
                      class="file-item"
                      @click="onClickDownloadProjectAttachment(projectAttachment)"
                    >
                      <img :src="require('@/assets/images/icons/download.png')" />
                    </div>
                    <div
                      v-if="projectAttachment.userId == signedInUser.id || project.projectOwnerId == signedInUser.id"
                      class="file-item"
                      @click="onClickDeleteProjectAttachment(projectAttachment)"
                    >
                      <img :src="require('@/assets/images/chat_tool_icons/trash.png')" />
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <upload-project-attachment-modal
      :modal="uploadProjectAttachmentModal"
      :requesting="uploadProjectAttachmentRequestiong"
      @close="closeUploadProjectAttachmentModal"
      @onClickUploadProjectAttachment="onClickUploadProjectAttachment"
    />
    <delete-project-attachment-modal
      :modal="deleteProjectAttachmentModalWithObject != null"
      :deleteProjectAttachment="deleteProjectAttachmentModalWithObject"
      :requesting="deleteProjectAttachmentRequesting"
      @close="closeDeleteProjectAttachmentModal"
      @onConfirmedDeleteProjectAttachment="onConfirmedDeleteProjectAttachment"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import DownloadPrivateFile from '@/lib/DownloadPrivateFile'

import Project from '@/store/models/Project'
import ProjectAttachment from '@/store/models/ProjectAttachment'

import DeleteProjectAttachmentModal from '@/components/molecules/projectMenuTab/DeleteProjectAttachmentModal'
import UploadProjectAttachmentModal from '@/components/molecules/projectMenuTab/UploadProjectAttachmentModal'

export default {
  name: 'ProjectMenuTabFiles',
  components: {
    DeleteProjectAttachmentModal,
    UploadProjectAttachmentModal
  },
  props: {
    requiredAPIRequest: Boolean
  },
  computed: {
    projectId: function() { return this.$route.params.id },
    project: function() { return Project.find(this.projectId) },
    projectAttachments: function() {
      return ProjectAttachment.query().where('projectId', Number(this.projectId)).orderBy('updatedAt', 'desc').get()
    },
    ...mapGetters({
      httpError: 'httpError',
      signedInUser: 'auth/signedInUser'
    })
  },
  data() {
    return {
      deleteProjectAttachmentModalWithObject: null,
      deleteProjectAttachmentRequesting: false,
      uploadProjectAttachmentModal: false,
      uploadProjectAttachmentRequestiong: false
    }
  },
  methods: {
    closeDeleteProjectAttachmentModal: function() {
      if (this.deleteProjectAttachmentRequesting) return
      this.deleteProjectAttachmentModalWithObject = null
    },
    closeUploadProjectAttachmentModal: function() {
      if (this.uploadProjectAttachmentRequestiong) return
      this.uploadProjectAttachmentModal = false
    },
    onClickDeleteProjectAttachment: function(projectAttachment) {
      this.deleteProjectAttachmentModalWithObject = projectAttachment
    },
    onClickDownloadProjectAttachment: function(projectAttachment) {
      this.downloadPrivateFile = new DownloadPrivateFile({
        url: projectAttachment.attachmentFile.url,
        fileName: projectAttachment.attachmentFileName
      })
      this.downloadPrivateFile.on('download', () => {
        this.downloadPrivateFile.download()
      })
    },
    async onClickUploadProjectAttachment(newProjectAttachment) {
      this.uploadProjectAttachmentRequestiong = true
      await this.apiPostProjectAttachments({
        projectId: this.projectId,
        attributes: newProjectAttachment
      })
      this.uploadProjectAttachmentRequestiong = false

      if (!this.httpError) {
        this.uploadProjectAttachmentModal = false
      }
    },
    async onConfirmedDeleteProjectAttachment() {
      this.deleteProjectAttachmentRequesting = true
      await this.apiDeleteProjectAttachments({
        projectId: this.projectId,
        id: this.deleteProjectAttachmentModalWithObject.id
      })
      this.deleteProjectAttachmentRequesting = false

      if (!this.httpError) {
        this.deleteProjectAttachmentModalWithObject = null
      }
    },
    ...mapActions({
      apiGetProjectAttachments: 'entities/projectAttachments/index',
      apiPostProjectAttachments: 'entities/projectAttachments/create',
      apiDeleteProjectAttachments: 'entities/projectAttachments/destroy'
    })
  },
  created() {
    this.apiGetProjectAttachments(this.projectId)
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/mediaquery";
@import "@/styles/variables";

.files-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.upload-wrapper {
  margin-bottom: 20px;
}

.content-container {
  flex-grow: 1;
  margin-left: -20px;
  height: 100%;
  width: calc(100% + 40px);

  .table-outer-wrapper {
    position: relative;
    height: 100%;
  }

  .table-inner-scroll-wrapper {
    position: absolute;
    max-height: 100%;
    width: 100%;
    overflow-y: auto;
  }

  .table-files {
    height: 100%;
    min-width: 100%;
    white-space: nowrap;

    thead th {
      position: sticky;
      top: 0;
      background-color: white;
      padding-right: 20px;

      &:first-child {
        padding-left: 20px;
      }

      .attribute-name {
        background-color: $light-gray-color;
        background-clip: content-box;

        span {
          display: block;
          padding: 7px 5px;
          font-size: 13px;
          font-weight: 300;
          color: $secondary-color;
        }
      }
    }

    tbody tr {
      border-bottom: 1px solid $light-border-color;

      td {
        padding: 20px 20px 20px 0;

        &:first-child {
          padding-left: 20px;
        }

        .file-items {
          display: flex;
          justify-content: flex-end;
        }

        .file-item {
          position: relative;
          cursor: pointer;
          width: 26px;
          height: 26px;
          padding: 3px;
          margin-left: 10px;
          border-radius: 4px;
          display: flex;

          &:hover {
            background-color: $background-color;
          }

          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
}
</style>
